
// Interface to translate products between Miam and Cora
// This is where the special conditions related to PFT products are handled,
// as well as the quantities updates are calculated
export class ComparisonItem {
  miamQuantity = 0;
  miamTargetQuantity = 0;
  miamBasketEntryIds = {};
  _retailerProducts = [];
  _basketWrapper;

  constructor(basketWrapper){
    this._basketWrapper = basketWrapper;
  }

  get retailerQuantity() {
    const quantities = this._retailerProducts.map(retailerProduct => retailerProduct.quantity);
    // make the sum
    return quantities.reduce((a,b) => parseInt(a) + parseInt(b), 0);

  }


  clearRetailerProduct() {
    this._retailerProducts = [];
  }

  // only for logging purpose
  get miamBasketEntryIdsToStr() {
    let res = '';
    Object.keys(this.miamBasketEntryIds).forEach(beId => {
      const qty = this.miamBasketEntryIds[beId];
      res += `${beId}: ${qty}, `
    });
    return res;
  }

  get firstBasketEntryId() {
    return Object.keys(this.miamBasketEntryIds)[0];
  }

  removeFirstMiamEntry(qtyToRemove){
    const firstKey = Object.keys(this.miamBasketEntryIds)[0];
    let quantity = this.miamBasketEntryIds[firstKey];
    if (quantity >  qtyToRemove) {
      this.miamBasketEntryIds[firstKey] = quantity - qtyToRemove;
      return [firstKey, qtyToRemove];
    } else {
      delete this.miamBasketEntryIds[firstKey];
      return [firstKey, quantity];
    }
  }

  // --------------------------------------------------------------------------------------------
  // --- COMING FROM Retailer -----------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  /**
   * _retailerProducts is a  array for some retailer (like cora)
   * so to have the moset standart code we turn it into an array
   * even if it's not needed
   * @param {array<{id:string, quantity:quantity}>} retailerProduct 
   */
  addOrUpdateRetailerProduct(retailerProduct) {
      if (this._retailerProducts.length === 0 || this.retailerQuantity === 0){
        this._retailerProducts = [retailerProduct];
        return;
      }
      const existingRetailerProduct = this._retailerProducts[0];
      existingRetailerProduct.quantity = retailerProduct.quantity;
      return;

  }


  // --------------------------------------------------------------------------------------------
  // --- COMING FROM MIAM -----------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  createRetailerProducts(basketEntry, targetQuantity){
    if (basketEntry.selectedItem) {    
      this._retailerProducts = [this._basketWrapper.mapProductToEntry(basketEntry.selectedItem.attributes, targetQuantity)];
    }
    return this._retailerProducts;
  }

  // will update cora quantity according to quantityDiff = compItem.miamTargetQuantity - compItem.miamQuantity
  // could be a simple update or a delete (or partial delete for pft items)
  // NB : compItem.miamTargetQuantity === 0 does NOT mean a total delete, for exemple if coraQuantity > miamQuantity
  updateRetailerProducts() {
    const quantityDiff = this.miamTargetQuantity - this.miamQuantity;
    if (quantityDiff === 0 || this._retailerProducts.length === 0){ // here length of cora product should never be 0 but security check it
      return [];
    }
         let item = this._retailerProducts[0];
      // TODO quantity / quantite ??
      item.quantity += quantityDiff;
      if (item.quantity <= 0 ) {
        // no more cora product, in this case miamQuantity should have been coraQuantity and miamTargetQuantity 0
        this.clearRetailerProduct();
      }
      return [item];
  }
}